* {
  box-sizing: border-box;
}

:host {
  display: block;
  max-width: 100%;
}

.wrapper {
  padding: 2px;
}

.wrapper-time-picker {
  display: flex;
  flex-direction: row;
  align-items: center;

  .dots {
    margin: 0 10px;
    color: var(--main-titles-inputs-600);
  }
}
